import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useState } from 'react';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

const EditSong = ({show, song, setShow, callback}) => {
    const [artist, setArtist] = useState();
    const [title, setTitle] = useState();
    const [artistUrl, setArtistUrl] = useState();
    const [cookies] = useCookies(['gaia-login']);
    
    useEffect(() => {
        if (!song) {
            return;
        }
        setArtist(song["artist"]);
        setTitle(song["title"]);
        setArtistUrl(song["artistUrl"]);
    }, [song]);

    const updateSong = () => {
        console.log("Updating song " + song["id"] + ": " + artist + ", " + title + ", " + artistUrl);
        const options = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Basic ' + btoa(cookies["gaia-login"]),
            },
            body: JSON.stringify({
                id: song["id"],
                artist,
                title,
                artistUrl,
            }),
        };
        fetch("https://europe-west1-voice-of-gaia.cloudfunctions.net/function-1", options).then(result => {
            console.log("RESULT: " + result);
            setShow(false);
            callback();
        });
    }

    return (
        <Modal show={show}>
          <Modal.Header closeButton>
            <Modal.Title>Edit song</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Form>
          <Form.Group as={Row} className="mb-3" controlId="artist">
            <Form.Label column sm="2">Artist</Form.Label>
            <Col sm="10">
                <Form.Control type="text" value={artist}  onChange={(e) => {setArtist(e.target.value)}} name="artist"/>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="title">
            <Form.Label column sm="2">Title</Form.Label>
            <Col sm="10">
                <Form.Control type="text" value={title}  onChange={(e) => {setTitle(e.target.value)}} name="title"/>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="artistUrl">
            <Form.Label column sm="2">Website</Form.Label>
            <Col sm="10">
                <Form.Control type="text" value={artistUrl}  onChange={(e) => {setArtistUrl(e.target.value)}} name="artistUrl"/>
            </Col>
          </Form.Group>
          </Form>
          </Modal.Body>
          <Modal.Footer>
          <Button variant="primary" onClick={() => {updateSong();}}>Save</Button>
          <Button variant="secondary" onClick={() => {setShow(false)}}>
            Close
          </Button>
        </Modal.Footer>
        </Modal>
    )
}

export default EditSong
